const isDev = process.env.NODE_ENV === "development";

export const API_BASE_URL = isDev
  ? "http://localhost:8000/api"
  : "https://fdmedia.us/api";

export const PREVIEW_BASE_URL = isDev
  ? "http://localhost:8000/preview/"
  : "https://fdmedia.us/preview/";

export const TOKEN_KEY = "fdmedia_admin_token";
